module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_tiempo_2018.a4f2845b.jpg";